import loading from '@/utils/loading';
import axios from 'axios';

// A propriedade process.env.APPLICATION_PATH é buscada da configuração do projeto
// e é gerenciada pelo webpack. É uma forma de criar variáveis de confuguração de acordo
// com o ambiente em que a aplicação está sendo executada.
// config/dev.env.js ~> ambiente de desenvolvimento
// config/prod.env.js ~> ambiente de produção
const BASE_URL = process.env.APPLICATION_PATH;

axios.defaults.timeout = 3600000;

export default class Http {

	static baseURL () {
		return BASE_URL;
	}

	static _getOptionValue (options, prop, defaultValue) {

		if (!options || !options.hasOwnProperty(prop)) {
			return defaultValue;
		} else {
			return options[prop];
		}
	}

	static _handleRequestPromisse (promisse, options) {

		promisse.then(response => {

			if (options.lockScreen) {
				Http._hideLoading(options);
			}

			if (options.success) {
				options.success(response.data, response);
			}

		}).catch(error => {
			
			if (options.error) {
				
				options.error(error.response.data);
			}

			if (options.lockScreen) {
				Http._hideLoading(options);
			}
		});
	}

	static _setDefaultOptions (options) {

		options = options || {};
		options.fullUrl = BASE_URL + options.url;
		options.lockScreen = Http._getOptionValue(options, 'lockScreen', true);
		options.lockMessage = options.lockMessage || 'Carregando';
		
		return options;
	}

	static _showLoading (options) {

		loading.show(options.lockMessage, options.lockElement);
	}

	static _hideLoading (options) {
		
		loading.hide(options.lockElement);
	}

	static get (options) {

		options = Http._setDefaultOptions(options);

		if (options.lockScreen) {
			Http._showLoading(options);
		}

		var promisse = options.data ? axios.get(options.fullUrl, { params: options.data }) : axios.get(options.fullUrl);

		Http._handleRequestPromisse(promisse, options);

		return promisse;
	}
	
	static post (options) {
		
		options = Http._setDefaultOptions(options);

		if (options.lockScreen) {
			Http._showLoading(options);
		}

		var promisse = axios.post(options.fullUrl, options.data);
		
		Http._handleRequestPromisse(promisse, options);

		return promisse;
	}

	static delete (options) {
		
		options = Http._setDefaultOptions(options);

		if (options.lockScreen) {
			Http._showLoading(options);
		}

		var promisse = options.data ? axios.delete(options.fullUrl, { params: options.data }) : axios.delete(options.fullUrl);

		Http._handleRequestPromisse(promisse, options);

		return promisse;
	}

	static put (options) {
		
		options = Http._setDefaultOptions(options);

		if (options.lockScreen) {
			Http._showLoading(options);
		}

		var promisse = axios.put(options.fullUrl, options.data);
		
		Http._handleRequestPromisse(promisse, options);

		return promisse;
	}
};



// WEBPACK FOOTER //
// ./src/services/http.js